import { IExpression } from "@@expressions";
import { IComponent } from "./IComponent";
import { IPanelModel } from "./IPanelModel";
import { PropertyDisplayModel } from "./PropertyDisplayModel";

export enum DataDisplayEditMode {
  InPlace = "InPlace",
  Dialog = "Dialog",
}

export type DataDisplayModel = IComponent &
  IPanelModel & {
    RowDirection?: boolean;
    GetData: IExpression;
    UpdateData?: IExpression;
    AutoEnterEditMode?: boolean;
    UsePaper?: boolean;
    EditMode?: DataDisplayEditMode;
    Properties: PropertyDisplayModel[];
  };
